import { RouteMap } from 'lib/router'
import { RouteChildrenProps } from 'react-router-dom'
import { WorkspaceSwitcherContainer } from 'containers/WorkspaceSwitcherContainer'
import { ConnectionsSelectorContainer } from 'containers/ConnectionsSelectorContainer'
import { OnboardingGateContainer } from 'containers/OnboardingGateContainer'
import { AdminInviteConfirmContainer } from 'containers/AdminInviteConfirmContainer'
import { OnboardingPublishContainer } from '../containers/OnboardingPublishContainer'
import { OnboardingWelcomeContainer } from 'containers/OnboardingWelcomeContainer'
import OnboardingFormContainer from 'containers/OnboardingFormContainer'
import MemberAcceptedContainer from 'containers/MemberAcceptedContainer'
import { ComponentType } from 'react'
import { InviteMemberLoginContainer } from 'containers/InviteMemberLoginContainer'

export const globalRoutes: RouteMap<{
  protected?: boolean
  fallBackComponent?: ComponentType<RouteChildrenProps>
}> = [
  {
    path: '/workspace-selector',
    component: WorkspaceSwitcherContainer,
    protected: true,
  },
  {
    path: '/invites/connections',
    component: ConnectionsSelectorContainer,
    protected: true,
  },
  {
    path: '/invites/organizations/:onboardingRecordId?',
    component: OnboardingGateContainer,
    protected: true,
  },
  {
    path: '/invites/admins',
    component: AdminInviteConfirmContainer,
    protected: true,
  },
  {
    path: '/welcome/:onboardingRecordId/form',
    component: OnboardingFormContainer,
    protected: true,
  },
  {
    path: '/welcome/:onboardingRecordId/publish',
    component: OnboardingPublishContainer,
    protected: true,
  },
  {
    path: '/welcome/:onboardingRecordId?',
    component: OnboardingWelcomeContainer,
    protected: true,
  },
  {
    path: '/invites/members',
    component: MemberAcceptedContainer,
    protected: true,
    fallBackComponent: InviteMemberLoginContainer,
  },
]
